/* Counterprice by Veritas UI — shared behaviour. Vanilla, idempotent, reduced-motion aware. */
(function(){
  if (window.__cpInit) return; window.__cpInit = true;
  var rm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var q = function(s, r){ return Array.prototype.slice.call((r||document).querySelectorAll(s)); };
  var fmt = function(n){ return '£' + Math.round(n).toLocaleString('en-GB'); };

  /* reveal (10 Oct 2026 perf pass): content is visible by default. Only blocks that start below the fold
     are marked .cp-pre (hidden) and faded in when they scroll into view. Hero content is never hidden,
     and a scroll check plus a print hook make sure nothing can be left invisible. */
  var docEl = document.documentElement;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting){ show(e.target); } });
  }, {rootMargin:'0px 0px -5% 0px', threshold:0}) : null;
  function show(el){ el.classList.add('is-in'); if (el.classList.contains('vh-r')) el.classList.add('in'); if (io) io.unobserve(el); }
  function reveal(){
    var animate = !!io && !rm && docEl.classList.contains('js');
    q('.cp-r:not(.is-in), .vh-r:not(.in)').forEach(function(el){
      if (el.classList.contains('cp-pre') || el.classList.contains('vh-pre')) return;
      var r = el.getBoundingClientRect();
      if (!animate || r.top < innerHeight || (r.width === 0 && r.height === 0)) { show(el); return; }
      el.classList.add(el.classList.contains('vh-r') ? 'vh-pre' : 'cp-pre'); io.observe(el);
    });
  }
  var sweepQueued = false;
  function sweep(){ sweepQueued = false;
    q('.cp-pre:not(.is-in), .vh-pre:not(.in)').forEach(function(el){ if (el.getBoundingClientRect().top < innerHeight) show(el); }); }
  addEventListener('scroll', function(){ if (!sweepQueued){ sweepQueued = true; requestAnimationFrame(sweep); } }, {passive:true});
  addEventListener('beforeprint', function(){ q('.cp-pre, .vh-pre').forEach(show); });

  /* count-up */
  function countUp(el){
    var end = parseFloat(el.getAttribute('data-count')), pre = el.getAttribute('data-pre')||'', suf = el.getAttribute('data-suf')||'';
    var dec = (String(end).split('.')[1]||'').length;
    if (rm){ el.textContent = pre + end.toFixed(dec) + suf; return; }
    var t0 = null, dur = 1400;
    function step(t){ if(!t0) t0=t; var p=Math.min(1,(t-t0)/dur); p = 1-Math.pow(1-p,3);
      el.textContent = pre + (end*p).toFixed(dec) + suf; if(p<1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  var cio = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ countUp(e.target); cio.unobserve(e.target);} });
  },{threshold:.6}) : null;
  function counts(){ q('[data-count]:not([data-counted])').forEach(function(el){ el.setAttribute('data-counted','1'); cio ? cio.observe(el) : countUp(el); }); }

  /* flip cards: tap on touch */
  function flips(){ q('.cp-flip').forEach(function(f){
    if (f.__cp) return; f.__cp = 1;
    f.setAttribute('tabindex','0'); f.setAttribute('role','button');
    var tog = function(){ f.classList.toggle('is-flipped'); };
    f.addEventListener('click', tog);
    f.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); tog(); } });
  }); }

  /* accordions */
  function accs(){ q('.cp-acc-btn').forEach(function(b){
    if (b.__cp) return; b.__cp = 1;
    b.addEventListener('click', function(){
      var item = b.closest('.cp-acc-item'), acc = b.closest('.cp-acc');
      var open = item.classList.contains('is-open');
      if (acc && acc.getAttribute('data-single')==='1') q('.cp-acc-item.is-open', acc).forEach(function(i){ i.classList.remove('is-open'); q('.cp-acc-btn',i)[0].setAttribute('aria-expanded','false'); });
      item.classList.toggle('is-open', !open); b.setAttribute('aria-expanded', String(!open));
    });
  }); }

  /* tabs */
  function tabs(){ q('[data-cp-tabs]').forEach(function(t){
    if (t.__cp) return; t.__cp = 1;
    var btns = q('[data-tab]', t), panels = q('[data-panel]', t);
    btns.forEach(function(b){ b.addEventListener('click', function(){
      btns.forEach(function(x){ x.classList.toggle('is-on', x===b); x.setAttribute('aria-selected', String(x===b)); });
      panels.forEach(function(p){ p.hidden = p.getAttribute('data-panel') !== b.getAttribute('data-tab'); });
    }); });
  }); }

  /* ticker: duplicate content once for seamless loop */
  function tickers(){ q('.cp-ticker-in').forEach(function(t){ if (t.__cp) return; t.__cp=1; t.innerHTML += t.innerHTML; }); }

  /* typewriter order slip */
  function slips(){ q('[data-cp-slip]').forEach(function(s){
    if (s.__cp) return; s.__cp = 1;
    var lines = q('li', s), i = 0;
    lines.forEach(function(l){ l.style.opacity = 0; });
    function next(){ if (i >= lines.length){ setTimeout(function(){ lines.forEach(function(l){ l.style.opacity=0; }); i=0; setTimeout(next,600); }, 4200); return; }
      var l = lines[i++]; l.style.transition='opacity .35s'; l.style.opacity=1; setTimeout(next, rm?0:520); }
    if (rm){ lines.forEach(function(l){ l.style.opacity=1; }); return; }
    var st = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){ if(es[0].isIntersecting){ next(); st.disconnect(); } },{threshold:.3}) : null;
    st ? st.observe(s) : next();
  }); }

  /* calculator: the same month through an app vs your own site */
  function calc(){ q('[data-cp-calc]').forEach(function(c){
    if (c.__cp) return; c.__cp = 1;
    var ov = c.querySelector('[data-ov]'), ow = c.querySelector('[data-ow]');
    var rate = parseFloat(c.getAttribute('data-rate')||'0.30'), monthly = parseFloat(c.getAttribute('data-monthly')||'204');
    var cardPct = 0.02, cardFix = 0.25, WK = 4.33;
    var t = function(sel){ return c.querySelector(sel); };
    var set = function(sel, v){ var el = t(sel); if (el) el.textContent = v; };
    var pct = function(n, of){ return Math.max(0, Math.min(100, n / of * 100)) + '%'; };
    function upd(){
      var v = +ov.value, w = +ow.value, om = w * WK, spend = om * v;
      var appCut = spend * rate, appKeep = spend - appCut;
      var card = om * (v * cardPct + cardFix), ownKeep = spend - card - monthly;
      var diff = ownKeep - appKeep;
      set('[data-ow-out]', w); set('[data-ov-out]', fmt(v));
      set('[data-spend]', fmt(spend));
      set('[data-app-cut]', fmt(appCut)); set('[data-app-keep]', fmt(appKeep));
      set('[data-card]', fmt(card)); set('[data-plan-cost]', fmt(monthly)); set('[data-own-keep]', fmt(Math.max(0, ownKeep)));
      t('[data-bar-app-keep]').style.width = pct(appKeep, spend); t('[data-bar-app-cut]').style.width = pct(appCut, spend);
      t('[data-bar-own-keep]').style.width = pct(ownKeep, spend); t('[data-bar-own-cut]').style.width = pct(card + monthly, spend);
      /* orders a week at this order value where your own site starts to win */
      var perOrder = v * (rate - cardPct) - cardFix, be = perOrder > 0 ? Math.ceil(monthly / (WK * perOrder)) : 0;
      var vd = t('[data-verdict]'), sn = t('[data-sentence]');
      if (diff >= 0) {
        vd.innerHTML = 'That’s <b>' + fmt(diff) + ' a month</b> more in your till. <b>' + fmt(diff * 12) + '</b> a year.';
        sn.textContent = w + (w === 1 ? ' order' : ' orders') + ' a week at ' + fmt(v) + ' is ' + fmt(spend) + ' a month. A delivery app keeps ' + fmt(appCut) + ' of it. Your own site costs ' + fmt(card + monthly) + ' all in, card fees and the plan included, so the rest stays with you.';
      } else {
        vd.innerHTML = 'At this volume an app is <b>' + fmt(-diff) + ' a month</b> cheaper.';
        sn.textContent = 'Your own site has a fixed cost of ' + fmt(monthly) + ' a month, so it needs a few orders to pay for itself. At ' + fmt(v) + ' an order it wins from about ' + be + ' orders a week.';
      }
      c.querySelectorAll('[data-dec],[data-inc]').forEach(function(b){
        var r = b.hasAttribute('data-dec') ? b.getAttribute('data-dec') : b.getAttribute('data-inc');
        var inp = r === 'ow' ? ow : ov;
        b.disabled = b.hasAttribute('data-dec') ? +inp.value <= +inp.min : +inp.value >= +inp.max;
      });
    }
    c.querySelectorAll('[data-dec],[data-inc]').forEach(function(b){ b.addEventListener('click', function(){
      var dec = b.hasAttribute('data-dec'), r = dec ? b.getAttribute('data-dec') : b.getAttribute('data-inc');
      var inp = r === 'ow' ? ow : ov, st = +inp.step || 1;
      inp.value = Math.min(+inp.max, Math.max(+inp.min, +inp.value + (dec ? -st : st))); upd();
    }); });
    ov.addEventListener('input', upd); ow.addEventListener('input', upd); upd();
  }); }

  /* pricing toggle */
  function ptog(){ q('[data-cp-ptog]').forEach(function(p){
    if (p.__cp) return; p.__cp = 1;
    q('[data-plan]', p).forEach(function(b){ b.addEventListener('click', function(){
      q('[data-plan]', p).forEach(function(x){ x.classList.toggle('is-on', x===b); });
      var plan = b.getAttribute('data-plan');
      q('[data-price]', p).forEach(function(el){ el.textContent = el.getAttribute('data-'+plan); });
    }); });
  }); }

  /* device carousel */
  function carousels(){ q('[data-cp-car]').forEach(function(c){
    if (c.__cp) return; c.__cp = 1;
    var slides = q('[data-slide]', c), dots = q('[data-dot]', c), i = 0, timer;
    function go(n){ i = (n+slides.length)%slides.length; slides.forEach(function(s,k){ s.classList.toggle('is-on', k===i); }); dots.forEach(function(d,k){ d.classList.toggle('is-on', k===i); }); }
    dots.forEach(function(d,k){ d.addEventListener('click', function(){ go(k); restart(); }); });
    q('[data-prev]',c).forEach(function(b){ b.addEventListener('click', function(){ go(i-1); restart(); }); });
    q('[data-next]',c).forEach(function(b){ b.addEventListener('click', function(){ go(i+1); restart(); }); });
    function restart(){ clearInterval(timer); if(!rm) timer = setInterval(function(){ go(i+1); }, 5000); }
    go(0); restart();
  }); }

  /* timeline progress */
  function timeline(){ q('[data-cp-line]').forEach(function(l){
    if (l.__cp) return; l.__cp = 1;
    var bar = l.querySelector('[data-line-fill]');
    function upd(){ var r = l.getBoundingClientRect(), vh = innerHeight; var p = Math.min(1, Math.max(0, (vh*0.75 - r.top) / r.height)); bar.style.transform = 'scaleY(' + p + ')'; }
    if (rm){ bar.style.transform='scaleY(1)'; return; }
    addEventListener('scroll', upd, {passive:true}); addEventListener('resize', upd); upd();
  }); }

  /* sticky bar after hero */
  function sticky(){ var bar = document.querySelector('.cp-sticky'); if(!bar || bar.__cp) return; bar.__cp=1;
    var hero = document.querySelector('[data-cp-hero]');
    function upd(){ var past = hero ? hero.getBoundingClientRect().bottom < 0 : scrollY > 600; bar.classList.toggle('is-on', past); }
    addEventListener('scroll', upd, {passive:true}); upd(); }

  /* floating labels */
  function floats(){ q('.cp-field input, .cp-field textarea').forEach(function(i){ if(i.__cp) return; i.__cp=1;
    var f = function(){ i.closest('.cp-field').classList.toggle('has-val', !!i.value); }; i.addEventListener('input', f); i.addEventListener('blur', f); f(); }); }

  function init(){ reveal(); counts(); flips(); accs(); tabs(); tickers(); slips(); calc(); ptog(); carousels(); timeline(); sticky(); floats(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
